module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations@3x.c0a5011c.png";